import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useApiClient } from 'hooks/useApiClient'

export type ResourceOrderCategory =
  | 'RedBinder'
  | 'Marketing'
  | 'Compliance'
  | 'None'

export interface ResourceReorderPayload {
  resourceCategoryId: number
  resourceIds: number[]
}

interface UseSaveResourceOrderParams {
  onSuccess?: (payload: ResourceReorderPayload) => void
  onError?: () => void
}

export const useSaveResourceOrder = ({
  onSuccess,
  onError,
}: UseSaveResourceOrderParams = {}) => {
  const { put } = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['resources/order'],
    mutationFn: async (payload: ResourceReorderPayload) => {
      const requestOptions: { body: ResourceReorderPayload } = { body: payload }

      const response = (await put(
        '/admin/resources/order' as never,
        requestOptions as never
      )) as {
        error?: { message?: string }
        data?: unknown
      }

      if (response.error !== undefined) {
        throw new Error(response.error.message ?? 'Error saving resource order')
      }

      return response
    },
    onSuccess: async (_response, payload) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/resources'],
      })
      onSuccess?.(payload)
    },
    onError: () => {
      onError?.()
    },
  })
}
